export const footer_i18n = {
    text1: "Datenschutz",
    text2: "AGB",
    text3: "Sitemap"
};